module.exports = __webpack_public_path__ + "static/media/ODS11.b496ccec.jpg";